var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "queryParams",
          attrs: {
            model: _vm.queryParams,
            inline: "",
            "label-width": "120px",
            "label-position": "left",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "流程定义名称" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入流程定义名称" },
                model: {
                  value: _vm.queryParams.processDefinitionName,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "processDefinitionName", $$v)
                  },
                  expression: "queryParams.processDefinitionName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "任务名称" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入任务名称" },
                model: {
                  value: _vm.queryParams.taskName,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryParams, "taskName", $$v)
                  },
                  expression: "queryParams.taskName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { "label-width": "0px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-search", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.refresh()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.reset()
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("table-page", {
        ref: "tablePage",
        attrs: {
          url: "/flow/task/getRunTaskList",
          columns: _vm.columns,
          "query-params": _vm.queryParams,
          "check-box": false,
        },
        scopedSlots: _vm._u([
          {
            key: "action",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.handleTask(row)
                      },
                    },
                  },
                  [_vm._v("办理任务")]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.dialogTaskShow
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "办理任务",
                visible: _vm.dialogTaskShow,
                width: "80%",
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogTaskShow = $event
                },
              },
            },
            [
              _c(
                "el-tabs",
                { attrs: { value: "form" } },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "表单", name: "form" } },
                    [
                      _c(_vm.formComponents[_vm.comName], {
                        tag: "component",
                        attrs: { "form-id": _vm.taskObj.formId },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "流程图", name: "process" } },
                    [
                      _c("track-process", {
                        attrs: {
                          "process-instance-id": _vm.taskObj.processInstanceId,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "center", padding: "20px" },
                      attrs: { span: 24 },
                    },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          attrs: {
                            model: _vm.form,
                            rules: _vm.rules,
                            "label-width": "80px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "审核批注", prop: "comment" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "请输入审核批注",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.change($event)
                                  },
                                },
                                model: {
                                  value: _vm.form.comment,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "comment", $$v)
                                  },
                                  expression: "form.comment",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    icon: "el-icon-circle-check",
                                    type: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleStatus(true)
                                    },
                                  },
                                },
                                [_vm._v("通过")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    icon: "el-icon-circle-close",
                                    type: "danger",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleStatus(false)
                                    },
                                  },
                                },
                                [_vm._v("驳回")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { icon: "el-icon-close" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.closeTaskDialog()
                                    },
                                  },
                                },
                                [_vm._v("关闭")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }